// config.js

export const appName = "compliance";

// Define your global variables
export const restApiUrl = "https://complianceapi.vistaarintuitivesolution.com";
export const authServer = "https://authserver.vistaarintuitivesolution.com";
export const comatHome = authServer + "/welcome";
export const appUrl = "https://compliance.vistaarintuitivesolution.com";

// Define your global variables
// export const restApiUrl = "http://127.0.0.1:8096";
// export const authServer = "http://meet05:9000";
// export const comatHome = authServer + "/welcome";
// export const appUrl = "http://127.0.0.1:3000/" + appName;

// export const comatHome = "http://127.0.0.1:9999";
// export const restApiUrl = "http://192.168.10.97:9083";
// export const authServer = "http://comat.gspcrop.net:8000";
// export const appUrl = "http://192.168.10.97:8080/" + appName;

// export const comatHome = "http://192.168.10.97";
// export const restApiUrl = "http://192.168.10.97:8083";
// export const authServer = "http://comat.gspcrop.net:9000";
// export const appUrl = "http://192.168.10.97:8080/" + appName;

// 'Accept': 'application/json',
export const headers = () => {
    const token = sessionStorage.getItem("id_token");
    const headers = new Headers();
    headers.set("Accept", "application/json");
    headers.set("Content-Type", "application/json");
    headers.set("Authorization", `Bearer ${token}`);
    return headers;
};

// Headers for multipart/form-data requests (file uploads)
// Don't set Content-Type - browser will set it automatically with boundary
export const multipartHeaders = () => {
    const token = sessionStorage.getItem("id_token");
    const headers = new Headers();
    headers.set("Authorization", `Bearer ${token}`);
    return headers;
};

export const COMPLIANCE_CAN_ADD_REGULATIONS = "Compliance Can Add Regulations";
export const COMPLIANCE_CAN_VIEW_REGULATIONS = "Compliance Can View Regulations";
export const COMPLIANCE_CAN_DELETE_REGULATIONS = "Compliance Can Delete Regulations";

export const COMPLIANCE_CAN_ADD_STANDARDS = "Compliance Can Add Standards";
export const COMPLIANCE_CAN_VIEW_STANDARDS = "Compliance Can View Standards";
export const COMPLIANCE_CAN_DELETE_STANDARDS = "Compliance Can Delete Standards";

export const COMPLIANCE_CAN_ADD_REQUIREMENTS = "Compliance Can Add Requirements";
export const COMPLIANCE_CAN_VIEW_REQUIREMENTS = "Compliance Can View Requirements";
export const COMPLIANCE_CAN_DELETE_REQUIREMENTS = "Compliance Can Delete Requirements";

export const COMPLIANCE_CAN_ADD_TASKS = "Compliance Can Add Tasks";
export const COMPLIANCE_CAN_REVIEW_TASKS = "Compliance Can Review Tasks";
export const COMPLIANCE_CAN_DELETE_TASKS = "Compliance Can Delete Tasks";

export const COMPLIANCE_CAN_MANAGE_MASTERDATA = "Compliance Can Manage MasterData";